import { useEffect, useState } from "react";
import { db } from "./firebase";
import { doc, getDoc } from "firebase/firestore";

export function useRuolo(uid) {
  const [ruolo, setRuolo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRuolo = async () => {
      if (uid) {
        const docRef = doc(db, "utenti", uid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setRuolo(docSnap.data().ruolo?.toLowerCase());
        }
      }
      setLoading(false);
    };
    fetchRuolo();
  }, [uid]);

  return { ruolo, loading };
}
